import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Card,
  CardContent,
  Button
} from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../component/ui/Loading";
import {
  AccountCircle,
  Email,
  Lock,
  Phone,
  AssignmentInd,
  LocationOn
} from "@mui/icons-material";
import "../../styles/App.scss";
import "../../styles/UserStyles.css";
import { EDIT_STAFF, STAFFS } from "../../component/common/Routes/AppRoutes";
import TextInputField from "../../component/ui/FormFields/TextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import {
  resetStaffDetail,
  StaffViewRequest
} from "../../redux/Staff/StaffAction";
import { fetchRoleDetailsRequest } from "../../redux/Roles/actions/RolesActions";
import { toast, ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
export default function ViewStaff() {
  const user = useSelector((state) => state.auth.user);
  const permissions = user?.permissions;
  const navigate = useNavigate();
  const location = useLocation();
  const viewStaff = useSelector((state) => state.staffs?.Staff || {});
  const viewLoading = viewStaff?.loading;
  const userData = useSelector((state) => state.staffs?.Staff.data || {});
  const role_name = useSelector(
    (state) => state.roles?.roleDetails?.data?.name || {}
  );

  const { control } = useForm();
  const loading = viewStaff?.loading;
  const dispatch = useDispatch();
  const { staffId } = useParams();

  const status = userData.status === 1 ? "Active" : "Inactive";

  useEffect(() => {
    if (staffId) {
      dispatch(StaffViewRequest(staffId));
    }
  }, [dispatch, staffId]);

  useEffect(() => {
    if (userData && userData.role_id) {
      dispatch(fetchRoleDetailsRequest(userData.role_id));
    }
  }, [dispatch, userData]);

  const staffFields = [
    {
      label: "First Name",
      value: userData.first_name || "-",
      icon: <AccountCircle />,
      sm: 6,
      xs: 12
    },
    {
      label: "Last Name",
      value: userData.last_name || "-",
      icon: <AccountCircle />,
      sm: 6,
      xs: 12
    },
    {
      label: "Email Address",
      value: userData.email || "-",
      icon: <Email />,
      sm: 6,
      xs: 12
    },

    {
      label: "Role",
      value: role_name || "-",
      icon: <AssignmentInd />,
      sm: 6,
      xs: 12
    },
    {
      label: "Code",

      value: userData.country_code || "-",
      sm: 2,
      xs: 4
    },
    {
      label: "Mobile Number",
      value: userData.phone || "-",
      icon: <Phone />,
      sm: 4,
      xs: 8
    },
    {
      label: "Gender",
      value: userData.gender_type || "-",
      icon: <AssignmentInd />,
      type: "radio",
      radioOptions: [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" }
      ],
      sm: 6,
      xs: 12
    },
    {
      label: "Date of Birth",
      value: userData.dob || "-",
      icon: <AssignmentInd />,
      sm: 6,
      xs: 12
    },
    {
      label: "Address1",
      value: userData.address1 || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    },
    {
      label: "Address2",
      value: userData.address2 || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    },
    {
      label: "Country",
      value: userData?.country_name?.replace("_", " ") || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    },

    {
      label: "State",
      value: userData?.state_name?.replace("_", " ") || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    },

    {
      label: "City",
      value: userData?.city_name?.replace("_", " ") || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    },

    {
      label: "Pincode",
      value: userData.pincode || "-",
      icon: <LocationOn />,
      sm: 6,
      xs: 12
    }
  ];
  if (viewLoading) {
    return <Loading text="Loading Staff details..." />;
  }

  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Card className="staff-card">
          <CardContent>
            <Typography variant="h5" className="form-heading">
              View Staff
            </Typography>
            <Grid
              container
              rowSpacing={4}
              columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              className="content-top-height"
            >
              {staffFields.map((field, index) => (
                <Grid item xs={field.xs} sm={field.sm} key={index}>
                  <TextInputField
                    label={field.label}
                    value={field.value}
                    disabled={true}
                    type={field.type}
                    radioOptions={field.radioOptions}
                    startAdornment={
                      <InputAdornment position="start">
                        {field.icon}
                      </InputAdornment>
                    }
                  />
                </Grid>
              ))}
            </Grid>
            {/* status */}
            <Grid item xs={12} sm={6}>
              <StatusRadioGroup
                defaultValue={status}
                name="status"
                control={control}
                disabled={true}
              />
            </Grid>
            {/* Buttons */}
            <Grid item xs={12}>
              <Box className="button-container">
                <CustomButton
                  variant="contained"
                  className="cancel-button"
                  type="button"
                  text={"back"}
                  link={STAFFS}
                />
                {(user?.user_type === 1 || permissions?.staffs?.edit) && (
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="button"
                    text={"Edit"}
                    link={`${EDIT_STAFF.replace(":staffId", staffId)}`}
                  />
                )}
              </Box>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
